<div class="table-responsive">
  <ng-container *ngIf="trackings.length > 0; else noTrackings">
    <table mat-table [dataSource]="trackings">

      <ng-container matColumnDef="work">
        <th mat-header-cell *matHeaderCellDef> Arbeit</th>
        <td mat-cell *matCellDef="let element"> {{ element.SEKUNDEN / 60 / 60 }}h</td>
      </ng-container>

      <ng-container matColumnDef="task">
        <th mat-header-cell *matHeaderCellDef> Vorgang</th>
        <td mat-cell *matCellDef="let element"> {{ element.AFOBEZ }}</td>
      </ng-container>

      <ng-container matColumnDef="serviceType">
        <th mat-header-cell *matHeaderCellDef> Leistungsart</th>
        <td mat-cell *matCellDef="let element"> {{ element.LEISTUNGSART }}</td>
      </ng-container>

      <ng-container matColumnDef="ratingType">
        <th mat-header-cell *matHeaderCellDef> Wertungsart</th>
        <td mat-cell *matCellDef="let element"> {{ element.WERTUNGSART }}</td>
      </ng-container>

      <ng-container matColumnDef="order">
        <th mat-header-cell *matHeaderCellDef> Auftrag</th>
        <td mat-cell *matCellDef="let element"> {{ element.AUFTRAGSNR }}</td>
      </ng-container>

      <ng-container matColumnDef="project">
        <th mat-header-cell *matHeaderCellDef> Projekt</th>
        <td mat-cell *matCellDef="let element"> {{ element.PROJEKTNR }}</td>
      </ng-container>

      <ng-container matColumnDef="bemi">
        <th mat-header-cell *matHeaderCellDef> Werkzeug</th>
        <td mat-cell *matCellDef="let element"> {{ element.BEMINR }}</td>
      </ng-container>

      <ng-container matColumnDef="pos">
        <th mat-header-cell *matHeaderCellDef> Position</th>
        <td mat-cell *matCellDef="let element"> {{ element.BEMIPOS }} {{ element.BEMIPOSBEZ }}</td>
      </ng-container>

      <ng-container matColumnDef="incident">
        <th mat-header-cell *matHeaderCellDef> Vorfall</th>
        <td mat-cell *matCellDef="let element"> {{ element.VORFALLNAME }}</td>
      </ng-container>

      <ng-container matColumnDef="comment">
        <th mat-header-cell *matHeaderCellDef> Bemerkung</th>
        <td mat-cell *matCellDef="let element"> {{ element.BEMERKUNG }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </ng-container>
  <ng-template #noTrackings>
    Keine Buchungen vorhanden.
  </ng-template>
</div>
